module.exports = __webpack_public_path__ + "static/media/trait-icons-achievement.5699df81.svg";